import React from "react";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

const Overview = () => {
  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "30px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          textAlign: "center",
          padding: "45px 30px",
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: "16px",
          boxShadow: "0 8px 30px rgba(15, 23, 42, 0.06)",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: "64px",
            height: "64px",
            margin: "0 auto 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            background: "#ecfdf5",
            color: "#059669",
          }}
        >
          <ConstructionOutlinedIcon style={{ fontSize: "32px" }} />
        </div>

        {/* Title */}
        <h2
          style={{
            margin: "0 0 10px",
            fontSize: "24px",
            fontWeight: 700,
            color: "#0f172a",
          }}
        >
          Overview
        </h2>

        {/* Coming Soon Badge */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "5px 12px",
            marginBottom: "16px",
            borderRadius: "20px",
            background: "#f0fdf4",
            color: "#15803d",
            fontSize: "12px",
            fontWeight: 700,
          }}
        >
          <AccessTimeOutlinedIcon style={{ fontSize: "15px" }} />
          Coming Soon
        </div>

        {/* Description */}
        <p
          style={{
            margin: 0,
            color: "#64748b",
            fontSize: "14px",
            lineHeight: 1.6,
          }}
        >
          The Overview dashboard is currently under development. It will be
          available soon with inventory insights, product statistics, stock
          status, and other key information.
        </p>
      </div>
    </div>
  );
};

export default Overview;
